export default axios => ({
    getList(conclusion, payLoad) {
        return axios.get(`/${conclusion}/market-products`, payLoad);
    }
})
